import { Shipment } from "@/model/transportorder/transportOrder"

import { State } from "./store"

export const getSelectedAdminTransportOrder
    = (store: State): Shipment | undefined => store.adminUi.selectedTransportOrder
